import { NgModule } from '@angular/core';
import { HttpClientModule, HttpHeaders } from '@angular/common/http';
// Apollo
import { ApolloModule, Apollo } from 'apollo-angular';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink, concat } from 'apollo-link';

import { environment } from '../environments/environment';

/** gqlLink  */
const uri = environment.gqlLink;

@NgModule({
    exports: [
        HttpClientModule,
        ApolloModule,
        HttpLinkModule
    ]
})
export class GraphQLModule {
    constructor(
        apollo: Apollo,
        httpLink: HttpLink
    ) {
        const http = httpLink.create({ uri });

        const authMiddleware = new ApolloLink((operation, forward) => {
            // add the authorization to the headers
            operation.setContext({
                headers: new HttpHeaders().set('Authorization', null)
            });

            return forward(operation);
        });
        apollo.create({
            link: http,
            cache: new InMemoryCache()
        });
    }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/graphql.module.ts